// extracted by mini-css-extract-plugin
export default {"menuIcon":"MenuIcon_menuIcon__2GuvK"};